// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"75ee2d06","912":"29c0ee8f"}[chunkId] + ".chunk.js";
};